<div #lineColor id="chartdiv" style="width: auto; height: 250px"></div>
